export default __webpack_public_path__ + "ea8a923ec6d3ea7cf7bc5ddefabbc20c.woff2";